import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent implements OnInit {
  @Input() controlName: string = '';
  @Input() group?: any = new FormGroup({});
  @Input() label?: string;

  constructor() {}

  ngOnInit(): void {}
}
